import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BASE_URL = "https://firststagetalent.com"; // Replace with actual domain

const useLanguageSEO = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.substring(0, 2) || "en";

  useEffect(() => {
    // Get path without language prefix
    const pathParts = location.pathname.split("/").filter(Boolean);
    const hasLangPrefix = pathParts[0] === "en" || pathParts[0] === "fr";
    const pathWithoutLang = hasLangPrefix ? "/" + pathParts.slice(1).join("/") : location.pathname;
    const cleanPath = pathWithoutLang === "/" ? "" : pathWithoutLang;

    // Build URLs for each language
    const enUrl = `${BASE_URL}/en${cleanPath}`;
    const frUrl = `${BASE_URL}/fr${cleanPath}`;
    const currentUrl = currentLang === "fr" ? frUrl : enUrl;

    // Remove existing hreflang and canonical tags
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
    document.querySelectorAll('link[rel="canonical"]').forEach(el => el.remove());

    // Add canonical
    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = currentUrl;
    document.head.appendChild(canonical);

    // Add hreflang for English
    const hreflangEn = document.createElement("link");
    hreflangEn.rel = "alternate";
    hreflangEn.hreflang = "en-CA";
    hreflangEn.href = enUrl;
    document.head.appendChild(hreflangEn);

    // Add hreflang for French
    const hreflangFr = document.createElement("link");
    hreflangFr.rel = "alternate";
    hreflangFr.hreflang = "fr-CA";
    hreflangFr.href = frUrl;
    document.head.appendChild(hreflangFr);

    // Add x-default (for users without language preference)
    const hreflangDefault = document.createElement("link");
    hreflangDefault.rel = "alternate";
    hreflangDefault.hreflang = "x-default";
    hreflangDefault.href = enUrl;
    document.head.appendChild(hreflangDefault);

    // Update html lang attribute
    document.documentElement.lang = currentLang === "fr" ? "fr-CA" : "en-CA";

    return () => {
      // Cleanup on unmount
      document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
      document.querySelectorAll('link[rel="canonical"]').forEach(el => el.remove());
    };
  }, [location.pathname, currentLang]);
};

export default useLanguageSEO;
